import React from 'react';
import WizardStepHeaderItem from "./wizardStepHeaderItem";

const _getVariant = (wizardStep, headerItemIndex) => {
    if(wizardStep + 1 === headerItemIndex){
        return 'active'
    }
    if(wizardStep + 1 > headerItemIndex){
        return 'complete'
    }
    if(wizardStep + 1 < headerItemIndex){
        return 'inactive'
    }
};

const WizardStepHeader = (props) => {
    return (
        <ul className={'nav nav-justified quote-wizard-header'}>
            {props.headerItems.map(item => (
                <WizardStepHeaderItem
                    key={item.key}
                    index={item.key + 1}
                    label={item.name}
                    variant={_getVariant(props.wizardStep, item.key + 1)}
                />
            ))}
        </ul>
    )
};

export default WizardStepHeader;